// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"3d17717f","556":"3d17717f"}[chunkId] + ".chunk.css";
};